module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }